'use strict';
import angular from 'angular';

angular.module('association.history.services', [])

    .factory('AssociationHistoryService', ['IORestangular', function (IORestangular) {

        let associationHistory = IORestangular.all('flights/associationHistory');
        let deleteAssociation = IORestangular.all('flights/deleteAssociation');

        let getAssociationHistoryForFlight = function (flightId) {
            return associationHistory.customGET(undefined, {flightId: flightId}, undefined, undefined);
        };

        let getAssociationHistoryForLineItem = function (lineItemId) {
            return associationHistory.customGET(undefined, {lineItemId: lineItemId}, undefined, undefined);
        };

        let getAssociationHistoryForOrder = function (orderId) {
            return associationHistory.customGET(undefined, {orderId: orderId}, undefined, undefined);
        };

        let deleteAssociationHistoryEntry = function (associationId) {
            return deleteAssociation.customPOST({id: associationId}, undefined, undefined, undefined);
        };

        return {
            getAssociationHistoryForFlight: getAssociationHistoryForFlight,
            getAssociationHistoryForLineItem: getAssociationHistoryForLineItem,
            getAssociationHistoryForOrder: getAssociationHistoryForOrder,
            deleteAssociationHistoryEntry: deleteAssociationHistoryEntry
        };
    }]);
